import {createTheme} from "@material-ui/core"

export const white = "#FFFFFF"
const theme = createTheme({
  palette: {
    primary: {main: "#2685AD", dark: "#1F6993", light: " #F2F2F2"},
    text: {
      primary: "#000000"
    },
    action: {
      active: "#7FB9D4"
    },
    background: {
      default: "#F9FDFD"
    }
  }
})
export default theme
